import { render } from "./DetailedAccounts.vue?vue&type=template&id=7d3ea9b0&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./DetailedAccounts.vue?vue&type=script&lang=js"
export * from "./DetailedAccounts.vue?vue&type=script&lang=js"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__